<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>
    <error-alert-dialog
      :show-error-alert-dialog="showErrorAlertDialog"
      :error="networkError" @dismissClicked="showErrorAlertDialog=false">
    </error-alert-dialog>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <lender-terms-and-conditions-view
      :terms-and-conditions-view-data="termsAndConditionsData"
      :show="showTermsAndConditions"
      :show-loan-details-summary="showLoanDetailsSummary"
      @submitTermsAndConditions="submitTermsAndConditions"
    ></lender-terms-and-conditions-view>

    <lender-otp-view
      ref="lenderOtpView"
      :show="showLenderOtpView"
      :logo="getLenderLogoUrl"
      :otp-error="otpError"
      :lender-otp-message="getOTPMessage"
      @onSubmitOtp="submitOtp"
      @onResendOtp="resendOtp"
    ></lender-otp-view>

    <esign-success-view
      :show="showEsignSuccessView"
      :heading="getSignSuccessHeading"
      :body="getSignSuccessBody"
      @onSignSuccess="onSignSuccess"
    ></esign-success-view>

    <esign-failure-view
      :show="showEsignFailedView"
      :reason-code="getErrorCode"
      :reason="getErrorMessage"
    ></esign-failure-view>
  </div>
</template>
<script>
import ToolBar from "../../layout/ToolBar";
import LenderTermsAndConditionsView from "../../layout/LenderTermsAndConditionsView";
import LenderOtpView from "../../layout/LenderOtpView";
import EsignSuccessView from "../../layout/EsignSuccessView";
import EsignFailureView from "../../layout/EsignFailureView";
import Loading from "../../layout/Loading";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import StageCommentItem from "../../layout/StageCommentItem";
import ErrorAlertDialog from "../../dialogs/ErrorAlertDialog";
import DataSource from "../../../data/DataSource";
import AlertService from "../../core/alert/AlertService";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import LoanTasksActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import { Activities } from "../../../utils/ActivityNavigator";
import RefreshItem from "../../layout/RefreshItem";
import storageUtil from "../../../utils/StorageUtil";
import { MessageConstants } from '../../../utils/MessageConstantUtil';

const OTP_SENT = "OTP has been sent";

export default {
  name: "LenderTermsAndConditionsActivity",
  components: {
    EsignFailureView,
    EsignSuccessView,
    LenderOtpView,
    LenderTermsAndConditionsView,
    ToolBar,
    Loading,
    ErrorAlertDialog,
    ActivityRedirectItem,
    StageCommentItem,
    RefreshItem
  },

  data: () => ({
    loading: false,
    showRefreshItem: false,
    showTermsAndConditions: false,
    showLenderOtpView: false,
    showEsignSuccessView: false,
    showEsignFailedView: false,
    serverError: null,
    showErrorAlertDialog: false,
    networkError: {},
    termsAndConditionsData: {},
    otpError: ""
  }),

  methods: {
    submitTermsAndConditions() {
      this.loading = true;
      DataSource.getLenderOtpView(LoanScopeDataHolder.getWebViewSecretKey())
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data)
          } else {
            this.termsAndConditionsData = res.data;
            this.makeViewsInvisible();
            if (this.termsAndConditionsData.errorCode) {
              this.showEsignFailedView = true;
            } else {
              this.showLenderOtpView = true;
              this.$refs.lenderOtpView.optSent();
            }
          }
        })
    },

    onSignSuccess() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.networkError = res.data;
            this.showErrorAlertDialog = true;
          }
        });
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.showErrorAlertDialog = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    submitOtp(event) {
      this.loading = true;
      DataSource.verifyLenderOtpAndGetResponse(LoanScopeDataHolder.getWebViewSecretKey(), event.otp)
        .then(res => {
          if (res.errorOccurred) {
            this.loading = false;
            this.otpError = res.data;
          } else {
            //TODO n need to get getEsignSuccessView view. Need to make document signing completed api. Right now getEsignSuccessView is doing that thing
            if (!res.data || !res.data.verificationStatus){
                this.loading = false;
                if (res.data && res.data.message){
                  this.otpError = res.data.message;
                } else {
                  this.otpError = MessageConstants.INVALID_LENDER_AGREEMENT_OTP;
                }
            } else {
              this.otpError = "";
              DataSource.getEsignSuccessView(LoanScopeDataHolder.getLoanId())
                .then(res => {
                  this.loading = false;
                  if (res.errorOccurred) {
                    this.showError(res.data)
                  } else {
                    this.onSignSuccess();
                  }
                })
            }
          }
        })
    },

    resendOtp() {
      this.loading = true;
      DataSource.resendLenderOtp(LoanScopeDataHolder.getWebViewSecretKey())
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data)
          } else {
            this.$refs.lenderOtpView.optSent();
            this.showToast(OTP_SENT);
          }
        })
    },

    makeViewsInvisible() {
      this.showTermsAndConditions = false;
      this.showLenderOtpView = false;
      this.showEsignSuccessView = false;
      this.showEsignFailedView = false;
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getLenderWebView(LoanScopeDataHolder.getWebViewSecretKey())
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
            this.showRefreshItem = true;
          } else {
            this.termsAndConditionsData = res.data;
            this.makeViewsInvisible();
            if (this.termsAndConditionsData.clientName) {
              this.showTermsAndConditions = true;
            } else if (this.termsAndConditionsData.signSuccessHeading) {
              this.showEsignSuccessView = true;
            } else if (this.termsAndConditionsData.errorCode) {
              this.showEsignFailedView = true
            }
          }
        })
    }
  },

  created: function () {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.SIGN_LENDER_DOCUMENT];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    getLenderLogoUrl() {
      return this.termsAndConditionsData ? this.termsAndConditionsData.lenderLogoUrl : "";
    },

    getOTPMessage() {
      return this.termsAndConditionsData && this.termsAndConditionsData.otpMessage !== "null"
        ? this.termsAndConditionsData.otpMessage
        : "";
    },

    getSignSuccessHeading() {
      return this.termsAndConditionsData ? this.termsAndConditionsData.signSuccessHeading : "";
    },

    getSignSuccessBody() {
      return this.termsAndConditionsData ? this.termsAndConditionsData.signSuccessBody : "";
    },

    getErrorCode() {
      return this.termsAndConditionsData ? this.termsAndConditionsData.errorCode : "";
    },

    getErrorMessage() {
      return this.termsAndConditionsData ? this.termsAndConditionsData.errorMessage : "";
    },

    showLoanDetailsSummary() {
      return !LoanScopeDataHolder.isOnboardingLoan();
    },

    toolbarTitle() {
      return LoanScopeDataHolder.isOnboardingLoan()
          ? "Merchant Agreement Signature" : "Loan Agreement Signature";
    },
  }
}
</script>

